class FarloUiTicketCalendar {
	constructor(element, _config) {
		this.container = element;
		this.options = _config;
		this.minDate = new Date(this.container.dataset.startMonth);
		this.maxDate = new Date(this.container.dataset.endMonth);
		this.startDay = this.container.dataset.startDay === 'monday' ? 1 : 0; // 1 for Monday, 0 for Sunday
		this.currentDate = new Date(this.container.dataset.startMonth);
		this.cache = {};
		this.render();
	}

	// renderHeader() {
	// 	const header = document.createElement('div');
	// 	header.classList.add('farlo-ui-ticket-calendar__header');

	// 	const title = document.createElement('h2');
	// 	title.classList.add('farlo-ui-ticket-calendar__header-month-year');
	// 	title.textContent = this.currentDate.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
	// 	header.appendChild(title);

	// 	const prevButton = document.createElement('button');
	// 	prevButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--prev', 'button');
	// 	prevButton.textContent = '<';

	// 	if (this.currentDate > this.minDate) {
	// 		prevButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
	// 		prevButton.addEventListener('click', () => this.prevMonth());
	// 	} else {
	// 		prevButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
	// 	}

	// 	header.appendChild(prevButton);

	// 	const nextButton = document.createElement('button');
	// 	nextButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--next', 'button');
	// 	nextButton.textContent = '>';

	// 	if (this.currentDate < this.maxDate) {
	// 		nextButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
	// 		nextButton.addEventListener('click', () => this.nextMonth());
	// 	} else {
	// 		nextButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
	// 	}

	// 	header.appendChild(nextButton);
	// 	this.container.appendChild(header);
	// }

	renderHeader() {
		const header = document.createElement('div');
		header.classList.add('farlo-ui-ticket-calendar__header');

		const title = document.createElement('h2');
		title.classList.add('farlo-ui-ticket-calendar__header-month-year');


		// const startOfWeek = new Date(this.currentDate);
		// const endOfWeek = new Date(this.currentDate);
		// startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay() + this.startDay);
		// endOfWeek.setDate(startOfWeek.getDate() + 6);

		// title.textContent = `${startOfWeek.toLocaleDateString()} - ${endOfWeek.toLocaleDateString()}`;
		// header.appendChild(title);

		const prevButton = document.createElement('button');
		prevButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--prev', 'button');
		prevButton.textContent = '<';
		if (this.currentDate > this.minDate) {
			prevButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
			prevButton.addEventListener('click', () => this.prevWeek());
		} else {
			prevButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
		}

		header.appendChild(prevButton);

		// Get start of the week
		const startOfWeek = new Date(this.currentDate);
		const currentDay = startOfWeek.getDay();
		const offset = (currentDay - this.startDay + 7) % 7;
		startOfWeek.setDate(startOfWeek.getDate() - offset);

		// Get end of the week
		const endOfWeek = new Date(startOfWeek);
		endOfWeek.setDate(startOfWeek.getDate() + 6);

		// Format helper
		const formatDate = (date) =>
			date.toLocaleDateString(undefined, {
				day: '2-digit',
				month: 'long'
			});

		title.textContent = `${formatDate(startOfWeek)} – ${formatDate(endOfWeek)}`;
		header.appendChild(title);



		const nextButton = document.createElement('button');
		nextButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--next', 'button');
		nextButton.textContent = '>';
		if (this.currentDate < this.maxDate) {
			nextButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
			nextButton.addEventListener('click', () => this.nextWeek());
		} else {
			nextButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
		}
		header.appendChild(nextButton);

		this.container.appendChild(header);
	}

	renderDaysOfTheWeeks() {
		const div = document.createElement('div');
		div.classList.add('farlo-ui-ticket-calendar__weeks');
		const daysLetters = this.startDay === 1 ? ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] : ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

		for (let i = 0; i < 7; i++) {
			const days = document.createElement('div');
			days.classList.add('farlo-ui-ticket-calendar__week-day');
			days.textContent = daysLetters[i];
			div.appendChild(days);
		}

		this.container.appendChild(div);
	}

	async fetchEventsForWeek(y, m, d) {
		const cacheKey = `${y}-${m}-${d}`;
		if (this.cache[cacheKey]) {
			this.renderCalendar(this.cache[cacheKey]);
			return;
		}

		const data = new URLSearchParams({
			action: 'getEventsForWeek',
			nonce: farloAjaxVendorHandler.nonce,
			year: y,
			month: m,
			day: d
		});

		this.container.classList.add('farlo-ui-ticket-calendar--loading');

		try {
			const response = await fetch(farloAjaxVendorHandler.ajaxurl, {
				method: 'POST',
				body: data,
				headers: {
					'Accept': 'application/json',
					'Content-type': 'application/x-www-form-urlencoded',
					'X-WP-Nonce': farloAjaxVendorHandler.nonce
				}
			});

			if (response.ok) {
				const responseData = await response.json();
				this.cache[cacheKey] = responseData.data.calendarCells;
				this.container.classList.remove('farlo-ui-ticket-calendar--loading');
				this.renderCalendar(this.cache[cacheKey]);
			}
		} catch (error) {
			console.error('Error fetching week data', error);
		}
	}

	// async fetchEventsForMonth(y, m) {
	// 	const cacheKey = `${y}-${m}`;
	// 	if (this.cache[cacheKey]) {
	// 		this.renderCalendar(this.cache[cacheKey]);
	// 		return;
	// 	}

	// 	const data = new URLSearchParams({
	// 		action: 'getEventsForMonth',
	// 		nonce: farloAjaxVendorHandler.nonce,
	// 		month: m,
	// 		year: y
	// 	});

	// 	this.container.classList.add('farlo-ui-ticket-calendar--loading');

	// 	try {
	// 		const response = await fetch(farloAjaxVendorHandler.ajaxurl, {
	// 			method: 'POST',
	// 			body: data,
	// 			headers: {
	// 				'Accept': 'application/json',
	// 				'Content-type': 'application/x-www-form-urlencoded',
	// 				'X-WP-Nonce': farloAjaxVendorHandler.nonce
	// 			}
	// 		});

	// 		if (response.ok) {
	// 			const responseData = await response.json();
	// 			this.cache[cacheKey] = responseData.data.calendarCells;
	// 			this.cacheMultiMonthData(responseData.data.multiMonthData);
	// 			this.container.classList.remove('farlo-ui-ticket-calendar--loading');
	// 			this.renderCalendar(this.cache[cacheKey]);
	// 		} else {
	// 			console.error('Response status not OK:', response.status);
	// 		}
	// 	} catch (error) {
	// 		console.error('There was an error!', error);
	// 	}
	// }

	cacheMultiMonthData(multiMonthData) {
		for (const [key, value] of Object.entries(multiMonthData)) {
			if (!this.cache[key]) {
				this.cache[key] = value;
			}
		}
	}

	renderCalendar(calendarCells) {
		this.container.innerHTML = '';
		this.renderHeader();
		this.renderDaysOfTheWeeks();
		if (calendarCells !== '') {
			this.container.insertAdjacentHTML('beforeend', calendarCells);
		}

		// this.container.innerHTML = '';
		// this.renderHeader();
		// if (calendarCells !== '') {
		// 	const grid = document.createElement('div');
		// 	grid.classList.add('farlo-ui-ticket-calendar__grid');
		// 	grid.innerHTML = calendarCells;
		// 	this.container.appendChild(grid);
		// }
	}

	async render() {
		this.container.innerHTML = '';
		this.renderHeader();
		this.renderDaysOfTheWeeks();
		//await this.fetchEventsForMonth(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1);
		await this.fetchEventsForWeek(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, this.currentDate.getDate());
	}

	prevWeek() {
		this.currentDate.setDate(this.currentDate.getDate() - 7);
		this.render();
	}

	nextWeek() {
		this.currentDate.setDate(this.currentDate.getDate() + 7);
		this.render();

	}

	// prevMonth() {
	// 	this.currentDate.setMonth(this.currentDate.getMonth() - 1);
	// 	this.render();
	// }

	// nextMonth() {
	// 	this.currentDate.setMonth(this.currentDate.getMonth() + 1);
	// 	this.render();
	// }

	handleEventClick(event) {
		if (this.options.eventClick) {
			this.options.eventClick(event);
		}
	}
}

export default FarloUiTicketCalendar;
